import uuidv1 from 'uuid/v1';
import { instantiate } from './component';

export function getNextConfigVersion(currentVersion) {
  const type = typeof (currentVersion);
  if (type === 'number') {
    return (currentVersion + 1) % 0xFFFFFF;
  }
  return `config_${uuidv1()}`;
}

/**
 * System configuration product slots
 * */

// old function, remove later
export function slotIsOpenAndHasProducts(key, config, configProductData) {
  const { attributes: configAtributes } = config;
  const { attributes: productAtributes } = configProductData;
  if (!configAtributes || !productAtributes) {
    return false;
  }
  const { sets: productsByCategory } = productAtributes;
  const { slots } = configAtributes;

  const slot = slots[key];
  if (slot !== null && slot !== false) {
    return false;
  }
  const productList = productsByCategory[key];
  if (!productList) {
    return false;
  }
  if (Array.isArray(productList)) {
    return productList.length > 0;
  }
  // Not an array but one product by itself
  return typeof productList === 'object';
}

// old function, remove later
export function getOpenSlotsWithProducts(config, configProductData) {
  if (!config || !configProductData) {
    return null;
  }
  const { attributes: configAtributes } = config;
  const { attributes: productAtributes } = configProductData;
  if (!configAtributes || !productAtributes) {
    return null;
  }
  const { slots } = configAtributes;

  const slotKeys = Object.keys(slots);
  return slotKeys.filter((key) => {
    return slotIsOpenAndHasProducts(key, config, configProductData);
  });
}
// **************************************************
// Controls
// **************************************************

function newControlResult(control, controlSet) {
  const id = control ? control.id : null;
  return { id, control, controlSet };
}

function getConfigControlSlotName(index) {
  return `controls-${index + 1}`;
}

function getProductControlSlotName(index) {
  return `control-${index + 1}`;
}

function getNumControlSets(products) {
  if (!products) {
    return null;
  }
  return 5;
}

export function getMaxConfigControls(config) {
  if (!config) {
    return 0;
  }
  return 5;
}

export function canAddControlToConfig(control, controlSet, config) {
  if (!config) {
    return false;
  }
  const maxControls = getMaxConfigControls(config);
  const { id, amount } = control;
  const { slots } = config.attributes;
  let amountFreeSlots = 0;

  // Count controls of the same ID & control set
  let numControls = 0;
  for (let i = 0; i < maxControls; i += 1) {
    const slotName = getConfigControlSlotName(i);
    const controlValue = slots[slotName];
    const controlId = controlValue ? controlValue.id : null;
    const controlProperty = controlValue ? controlValue.property : null;

    if (controlId === id && controlProperty === controlSet) {
      numControls += 1;
    }
  }
  if (numControls === amount) {
    // Control(s) of the same set & id already added
    return false;
  }

  for (let i = 0; i < maxControls; i += 1) {
    const slotName = getConfigControlSlotName(i);
    const controlValue = slots[slotName];
    const controlId = controlValue ? controlValue.id : null;
    const controlProperty = controlValue ? controlValue.property : null;

    if (!controlValue || (controlId === id && controlProperty === controlSet)) {
      amountFreeSlots += 1;
    }
  }
  return amountFreeSlots >= amount;
}

export function getAvailableNewControlsForConfig(config, products, result = null) {
  if (!config || !products) {
    return null;
  }
  const { sets } = products.attributes;
  const numControlSets = getNumControlSets(products);
  const res = result || [];
  for (let i = 0; i < numControlSets; i += 1) {
    const setName = getProductControlSlotName(i);
    const controlSet = sets[setName];
    const numControlsInSet = controlSet ? controlSet.length : 0;
    for (let j = 0; j < numControlsInSet; j += 1) {
      const controlProductData = controlSet[j];
      if (canAddControlToConfig(controlProductData, setName, config)) {
        res.push(newControlResult(controlProductData, setName));
      }
    }
  }
  return res;
}

function countSimilarControlSlots(controlId, controlSet, config) {
  const { slots } = config.attributes;

  const numControls = getMaxConfigControls(config);
  let count = 0;
  for (let i = 0; i < numControls; i += 1) {
    const slotName = getConfigControlSlotName(i);
    const controlInSlot = slots[slotName];
    if (controlInSlot && controlInSlot.id === controlId && controlInSlot.property === controlSet) {
      count += 1;
    }
  }
  return count;
}

export function canRemoveControlFromConfig(controlSlot, config, products) {
  if (!controlSlot || !config) {
    return false;
  }
  if (!products) {
    return true;
  }
  const { slots } = config.attributes;
  const control = slots[controlSlot];
  if (!control) {
    return false;
  }
  const { id, property } = control;
  const setName = property;
  const { sets } = products.attributes;
  const controlSet = sets[setName];

  const numControlsInSet = controlSet ? controlSet.length : 0;
  const numControlsInGroup = countSimilarControlSlots(id, property, config);
  const nextAmountOfControlsInGroup = numControlsInGroup - 1;

  for (let i = 0; i < numControlsInSet; i += 1) {
    const controlProduct = controlSet[i];
    if (controlProduct.id === id) {
      if (!controlProduct.required || controlProduct.amount >= nextAmountOfControlsInGroup) {
        return true;
      }
    }
  }
  return false;
}

function getNextAvailableControlSlotIndex(config, fromIndex = 0) {
  const { slots } = config.attributes;
  const numSlots = getMaxConfigControls(config);
  for (let i = fromIndex; i < numSlots; i += 1) {
    const slotName = getConfigControlSlotName(i);
    const slot = slots[slotName];
    if (slot === false || slot === null) {
      return i;
    }
  }
  return -1;
}

// Remove control from config without checking if it is permitted
// Removes all controls with the same ID & set
function removeControlFromConfigInternal(control, controlSet, config) {
  if (!config) {
    return;
  }
  let controlId;
  if (typeof (control) === 'number' || typeof (control) === 'string') {
    controlId = control;
  } else if (control && typeof (control) === 'object') {
    controlId = control.id;
  }
  const numControls = getMaxConfigControls(config);
  const { slots } = config.attributes;
  const keepSlots = [];
  // Collect controls to keep
  for (let i = 0; i < numControls; i += 1) {
    const slotName = getConfigControlSlotName(i);
    const slotValue = slots[slotName];

    if (slotValue && (slotValue.id !== controlId || slotValue.property !== controlSet)) {
      keepSlots.push(slotValue);
    }
  }

  const numKeepSlots = keepSlots.length;
  // Reassign remaining controls
  for (let i = 0; i < numControls; i += 1) {
    const slotName = getConfigControlSlotName(i);

    const slotValue = i < numKeepSlots ? keepSlots[i] : false;
    slots[slotName] = slotValue;
  }
}

const indexByConfigControlSlotName = {
  'controls-1': 0,
  'controls-2': 1,
  'controls-3': 2,
  'controls-4': 3,
  'controls-5': 4,
};

export function addControlToConfig(control, controlSet, config, configSlot = null) {
  if (!canAddControlToConfig(control, controlSet, config)) {
    return false;
  }
  removeControlFromConfigInternal(control, controlSet, config);

  const { slots } = config.attributes;

  const { id, amount } = control;
  const property = controlSet;

  let currentSlotIndex = configSlot ? indexByConfigControlSlotName[configSlot] || 0 : 0;
  for (let i = 0; i < amount; i += 1) {
    currentSlotIndex = getNextAvailableControlSlotIndex(config, currentSlotIndex);
    if (currentSlotIndex < 0) {
      return false;
    }
    const slotName = getConfigControlSlotName(currentSlotIndex);
    slots[slotName] = {
      id,
      property,
    };
  }
  return true;
}

// TODO: remove export
export function addControlsGroupToConfig(groups, config) {
  if (!groups || !config) {
    return;
  }
  let array = groups;
  if (groups.controlSets) {
    array = groups.controlSets;
  }
  let index = 0;
  const { slots } = config.attributes;
  const numGroups = array.length;
  for (let i = 0; i < numGroups; i += 1) {
    const group = array[i];
    const { amount, id, set } = group;
    for (let j = 0; j < amount; j += 1) {
      const slotName = getConfigControlSlotName(index);
      slots[slotName] = {
        id,
        property: set,
      };

      index += 1;
    }
  }
  const maxNumControls = getMaxConfigControls(config);
  if (index < maxNumControls) {
    for (let i = index; i < maxNumControls; i += 1) {
      const slotName = getConfigControlSlotName(i);
      slots[slotName] = false;
    }
  }
}

function groupControls(config) {
  const num = getMaxConfigControls(config);
  const { slots } = config.attributes;
  const map = {};
  const controlSets = [];
  const controlSetsBySlotname = {};
  for (let i = 0; i < num; i += 1) {
    const slotName = getConfigControlSlotName(i);
    const slotValue = slots[slotName];
    if (slotValue) {
      const { id, property } = slotValue;
      const idKey = typeof (id) === 'number' ? id.toString(16) : id;
      const key = `${property}_${idKey}`;
      let controlSet = map[key];
      if (!controlSet) {
        controlSet = {
          id,
          amount: 0,
          set: property,
          controls: [],
          slots: [],
        };
        map[key] = controlSet;
        controlSets.push(controlSet);
      }
      controlSet.amount += 1;
      controlSet.controls.push(slotValue);
      controlSet.slots.push(slotName);
      controlSetsBySlotname[slotName] = controlSet;
    }
  }
  return { controlSets, controlSetsBySlotname };
}

export function getControlProductById(id, products, controlSlotName = null, amount = -1, multiple = false) {
  const { sets } = products.attributes;
  const num = getNumControlSets(products);
  let res = null;
  if (multiple) {
    res = [];
  }
  for (let i = 0; i < num; i += 1) {
    const slotName = getProductControlSlotName(i);

    if (!controlSlotName || (slotName === controlSlotName)) {
      const set = sets[slotName];
      if (set) {
        const setCount = set.length;
        for (let j = 0; j < setCount; j += 1) {
          const product = set[j];
          if (product && product.id === id) {
            if (amount <= 0 || product.amount === amount) {
              const resObj = newControlResult(product, slotName);
              if (multiple) {
                res.push(resObj);
              } else {
                return resObj;
              }
            }
          }
        }
      }
    }
  }
  return res;
}

// Internal function used by replaceControlInConfigAction
function replaceControlOfSetAction(action, controlId, controlAmount, setName, set, numAvailableSlots, result) {
  if (set) {
    for (let i = 0, length = set.length; i < length; i += 1) {
      const product = set[i];
      const { id: productId, amount: productAmount } = product;
      // If not the original product
      // & if the amount is smaller than or equal to the number of available slots
      if ((productId !== controlId || productAmount !== controlAmount) && productAmount <= numAvailableSlots) {
        if (action === 'check') {
          return true;
        } else if (action === 'collect') {
          // result.push({ id: product ? product.id : null, control: product, controlSet: setName });
          result.push(newControlResult(product, setName));
        }
      }
    }
  }
  if (action === 'check') {
    return false;
  } else if (action === 'collect') {
    return result;
  }
  return null;
}

/**
 * @function replaceControlInConfigAction
 * @private
 * @description - internal function to be used for different control replacement actions,
 *  like checking if a control can be replaced, collect all controls that can be replaced, ..
 * @param {string} action
 *  'check': returns true / false if a control can be replaced
 *  'collect': collects all products that can replace the old product
 * @param {string} controlSlot - 'controls-1', 'controls-2', 'controls-3', 'controls-4' or 'controls-5'
 * @param {object} config - system definition
 * @param {object} products - system products
 * @param {object} newControl - optional new control. If null, the function checks if the old control can be replaced by any new one
 * @param {string} newControlSet - optional name of the set of the new control ('control-1', 'control-2', ...)
 * TODO: refactor this monster
 * */
function replaceControlInConfigAction(action, controlSlot, config, products, newControl = null, newControlSet = null, data = null) {
  const actionCheck = action === 'check';
  const actionCollect = action === 'collect';
  if (!controlSlot || !config || !products) {
    // Invalid parameters, return immediately
    if (actionCheck) {
      return false;
    } else if (actionCollect) {
      return [];
    }
    return null;
  }
  /*
  A control can be replaced if another set of controls or single control can be added to the config
  */

  let result = null;

  if (actionCollect) {
    // Prepare result array if action === 'collect'
    if (data) {
      result = Array.isArray(data) ? data : data.result;
    }
    result = result || [];
  }

  const { slots } = config.attributes;
  const oldValue = slots[controlSlot];
  if (!oldValue) {
    // For some unknown reason, the current value on that slot is null / undefined / false
    if (newControl && newControlSet) {
      // newControl & newControlSet are defined -> check for that specific product if it can be added
      const canAddNewControl = canAddControlToConfig(newControl, newControlSet, config);
      if (actionCheck) {
        // Check if new control can be added
        return canAddNewControl;
      } else if (actionCollect && canAddNewControl) {
        // Push new control to result array if action === 'collect'
        result.push(newControlResult(newControl, newControlSet));
        return result;
      }
      return null;
    }
    const availableNewControls = getAvailableNewControlsForConfig(config, products);
    if (actionCheck) {
      return availableNewControls ? availableNewControls.length > 0 : false;
    } else if (actionCollect) {
      result.push(...availableNewControls);
    }
    return null;
  }

  const { sets } = products.attributes;

  const controlGroups = groupControls(config);
  const replacementGroup = controlGroups.controlSetsBySlotname[controlSlot];
  const { controlSets } = controlGroups;
  let newAmountUsed = 0;
  controlSets.forEach((controlSet) => {
    if (replacementGroup !== controlSet) {
      newAmountUsed += controlSet.amount;
    }
  });
  const numControlSlots = getMaxConfigControls(config);
  const newAmountAvailable = numControlSlots - newAmountUsed;

  const { control: oldValueProduct, controlSet: oldValueProductSet } = getControlProductById(oldValue.id, products);
  const oldValueRequired = oldValueProduct.required;

  if (newControl && newControlSet) {
    const slotsAvailableAfter = newControl.amount <= newAmountAvailable;
    if (actionCheck) {
      if (!slotsAvailableAfter) {
        return false;
      }
      // If required, set of the new control should be the same as the old one's
      return !oldValueRequired || (newControlSet === oldValueProductSet);
    }
  }

  if (oldValueRequired) {
    // Required -> Replacement only from the same set
    const setName = replacementGroup.set;
    const set = replacementGroup && replacementGroup.set ? sets[setName] : null;
    const replaceControlOfSetActionResult = replaceControlOfSetAction(
      action, replacementGroup.id, replacementGroup.amount, setName, set, newAmountAvailable, result);

    if (actionCheck) {
      return !!replaceControlOfSetActionResult;
    } else if (actionCollect) {
      return replaceControlOfSetActionResult;
    }
  } else {
    // Not required -> Check for all controls
    const numControlSets = getNumControlSets(products);
    for (let i = 0; i < numControlSets; i += 1) {
      const setName = getProductControlSlotName(i);
      const set = sets[setName];
      const replaceControlOfSetActionResult = replaceControlOfSetAction(
        action, replacementGroup.id, replacementGroup.amount, setName, set, newAmountAvailable, result);
      if (actionCheck) {
        return !!replaceControlOfSetActionResult;
      } else if (actionCollect) {
        result = replaceControlOfSetActionResult;
      }
    }
    return result;
  }
  return null;
}

/**
 * @function canReplaceControlInConfig
 * @description - Checks if a control can be replaced by other controls
 *  canReplaceControlInConfig(controlSlot, config, products):  check if a control in a system config can be replaced by any other control in the system products
 *  canReplaceControlInConfig(controlSlot, config, products, newControl, newControlSet): check if a control in a system config can be replaced by a specific other control
 * @param {string} controlSlot - 'controls-1', 'controls-2', 'controls-3', 'controls-4' or 'controls-5'
 * @param {object} config - system definition
 * @param {object} products - system products
 * @param {object} newControl - optional new control. If null, the function checks if the old control can be replaced by any new one
 * @param {string} newControlSet - optional name of the set of the new control ('control-1', 'control-2', ...)
 * @return {boolean} - true if the control can be replaced
 * */
export function canReplaceControlInConfig(controlSlot, config, products, newControl = null, newControlSet = null) {
  return replaceControlInConfigAction('check', controlSlot, config, products, newControl, newControlSet);
}

export function replaceControlInConfig(controlSlot, config, newControl, newControlSet, products) {// eslint-disable-line
  // if (!canReplaceControlInConfig(controlSlot, config, newControl, newControlSet, products)) {
  //   return false;
  // }
  const { slots } = config.attributes;
  const oldValue = slots[controlSlot];
  if (!oldValue) {
    return addControlToConfig(newControl, newControlSet, config, controlSlot);
  }

  const controlGroups = groupControls(config);
  const oldControl = controlGroups.controlSetsBySlotname[controlSlot];

  const { amount } = oldControl; // eslint-disable-line
  const newAmount = newControl ? newControl.amount : 0; // eslint-disable-line
  // TODO: work in progress

  return true;
}

export function getAvailableReplacementControlsForConfig(controlSlot, config, products, result = null) {
  if (!config || !products) {
    return null;
  }
  const { sets } = products.attributes;
  const numControlSets = getNumControlSets(products);
  const res = result || [];
  for (let i = 0; i < numControlSets; i += 1) {
    const setName = getProductControlSlotName(i);
    const controlSet = sets[setName];
    const numControlsInSet = controlSet ? controlSet.length : 0;
    for (let j = 0; j < numControlsInSet; j += 1) {
      const controlProductData = controlSet[j];

      if (canReplaceControlInConfig(controlSlot, config, controlProductData, setName, products)) {
        res.push(newControlResult(controlProductData, controlSet));
      }
    }
  }
  return res;
}
//

export function addProductToConfig(config, product, category, set = null, destinationSlot = null) {
  if (category === 'controllers' || category === 'controls' || category === 'controller' || category === 'control') {
    return addControlToConfig(product, set, config, destinationSlot);
  }
  const { slots } = config.attributes;
  const currentValue = slots[category];
  if (currentValue === false || (currentValue && typeof currentValue === 'object')) {
    slots[category] = instantiate(product);
    return true;
  }
  return false;
}

// TODO: work in progress
export function canRemoveProductFromConfig(slotName, config, product) {
  if (slotName === 'exhaust' || slotName === 'chimney') {
    return false;
  }
  if (!product) {
    return true;
  }
  const { required } = product;
  return required !== true && required !== 1;
}

export function canReplaceProductInConfig(slotName, systemDefinition, product, systemProductsData) {
  const data = systemDefinition.attributes.slots[slotName];
  const dataId = data ? data.id : null;

  if (slotName === 'solar-kit') {
    const solarData = systemProductsData.attributes.solar;
    const num = solarData.length;
    for (let i = 0; i < num; i += 1) {
      const item = solarData[i];
      const solarKit = item['solar-kit'];
      if (solarKit.id !== dataId) {
        return true;
      }
    }
    return true;
  }

  // Default behavior:
  const sets = systemProductsData.attributes.sets;
  const set = sets[slotName];
  if (!set) {
    return false;
  }
  const num = set.length;
  for (let i = 0; i < num; i += 1) {
    const item = set[i];
    if (item && item.id !== dataId) {
      return true;
    }
  }
  return false;
}


// Solar kit

// Find that fucking solar piece of shit
export function findSolarKitProductData(slotName, systemDefinition, systemProducts) {
  // Note: most products are under 'sets', solar kits are under 'solar'
  const solarKitData = systemDefinition.attributes.slots[slotName];
  if (!solarKitData) {
    return null;
  }
  const solarKitId = solarKitData.id;
  const solarArray = systemProducts.attributes.solar;
  if (!solarArray) {
    return null;
  }
  // I know looping each time to find the product data is heavy,
  // I could instead of cache this data somehow,
  // but unfortunately there is NO TIME to optimize this a.t.m.
  // And yes I'm very frustrated
  for (let i = 0, length = solarArray.length; i < length; i += 1) {
    // item is a set of pipings & a solar kit, not the solar kit itself,
    // so look for id in solar-kit.id
    const item = solarArray[i];
    const itemSolarData = item['solar-kit'];
    if (itemSolarData.id === solarKitId) {
      return item;
    }
  }
  return null;
}

const COMPONENT_TYPES = [
  { type: 'kettle', slot: 'kettle', set: 'kettle', aliases: ['kettle', 'kettles'] },
  { type: 'pump', slot: 'pump', set: 'pump', aliases: ['pump', 'pumps', 'heatpump', 'heatpumps', 'heat-pump', 'heat-pumps', 'heat_pump', 'heat_pumps'] },
  { type: 'boiler', slot: 'boiler', set: 'solar_boiler', aliases: ['boiler', 'solar_boiler', 'solar-boiler', 'solarboiler'] },
  { type: 'external_unit', slot: 'external_unit', set: null, aliases: ['external_unit', 'external_units', 'external-unit', 'external-units'] },
  { type: 'solar-kit', slot: 'solar-kit', set: null, aliases: ['solar-kit', 'solar_kit', 'solar-kits', 'solar_kits', 'solar_collector', 'solar-collector', 'solar_collectors', 'solar-collectors'] },
  { type: 'exhaust', slot: 'exhaust', set: null, aliases: ['exhaust', 'exhausts', 'chimney', 'chimneys'] },
];

const SLOT_SET_ALIAS_MAP = {};
const SLOT_SET_TYPE_ALIAS_MAP = {};

{
  const hydraulicsWords = [];
  const controllerWords = [];
  const hydraulicsType = { type: 'hydraulics', aliases: hydraulicsWords };
  const controllerType = { type: 'controller', aliases: controllerWords };

  const controllerTypes = [];
  const hydraulicsTypes = [];

  const MAX = 10;
  controllerTypes.length = MAX;
  hydraulicsTypes.length = MAX;

  for (let i = 0; i < MAX; i += 1) {
    const contrSlotName = `controls-${i + 1}`;
    const contrSetName = `control-${i + 1}`;
    const hydrSlotName = `hydraulics-${i + 1}`;
    const hydrSetName = hydrSlotName;

    const hydrAliases = [
      hydrSlotName,
      `hydraulics_${i + 1}`,
    ];
    const contrAliases = [
      `controller-${i + 1}`,
      `controllers-${i + 1}`,
      contrSetName,
      contrSlotName,

      `controller_${i + 1}`,
      `controllers_${i + 1}`,
      `control_${i + 1}`,
      `controls_${i + 1}`,
    ];

    const contrName = `controller-${i + 1}`;
    const hydrName = `hydraulics-${i + 1}`;

    const contrType = {
      type: contrName,
      slot: contrSlotName,
      set: contrSetName,
      index: i,
      aliases: contrAliases,
      parent: controllerType,
    };

    const hydrType = {
      type: hydrName,
      slot: hydrSlotName,
      set: hydrSetName,
      index: i,
      aliases: hydrAliases,
      parent: hydraulicsType,
    };

    controllerTypes[i] = contrType;
    hydraulicsTypes[i] = hydrType;

    for (let j = 0, length = hydrAliases.length; j < length; j += 1) {
      const value = hydrAliases[j];
      SLOT_SET_ALIAS_MAP[value] = hydrType;
      hydraulicsWords.push(value);
    }
    for (let j = 0, length = contrAliases.length; j < length; j += 1) {
      const value = contrAliases[j];
      SLOT_SET_ALIAS_MAP[value] = contrType;
      controllerWords.push(value);
    }
  }
  controllerWords.push('controller');
  controllerWords.push('controllers');
  controllerWords.push('control');
  controllerWords.push('controls');
  hydraulicsWords.push('hydraulics');

  COMPONENT_TYPES.push(hydraulicsType);
  COMPONENT_TYPES.push(controllerType);

  const num = COMPONENT_TYPES.length;
  for (let i = 0; i < num; i += 1) {
    const componentType = COMPONENT_TYPES[i];
    const typeName = componentType ? componentType.type : null;
    if (typeName) {
      SLOT_SET_TYPE_ALIAS_MAP[typeName] = componentType;
    }
    if (componentType !== hydraulicsType && componentType !== controllerType) {
      SLOT_SET_ALIAS_MAP[typeName] = componentType;
    }
    const words = componentType ? componentType.aliases : null;
    const numWords = words ? words.length : 0;
    for (let j = 0; j < numWords; j += 1) {
      const word = words[j];
      SLOT_SET_TYPE_ALIAS_MAP[word] = componentType;
    }
  }
}

function getFromSetOrSlot(key, setOrSlot) {
  if (!key) {
    return null;
  }
  if (typeof (key) === 'object') {
    return key;
  }
  const keyLc = key.toLowerCase();
  let res = setOrSlot[keyLc];
  if (res) {
    return res;
  }
  const componentType = SLOT_SET_ALIAS_MAP[keyLc];
  const words = componentType ? componentType.aliases : null;
  const numWords = words ? words.length : 0;
  for (let i = 0; i < numWords; i += 1) {
    const word = words[i];
    res = setOrSlot[word];
    if (res) {
      return res;
    }
  }
  return res;
}

export function getObjectAtSystemDefinitionSlot(slot, systemDefinition) {
  if (!slot || !systemDefinition) {
    return null;
  }
  const { attributes } = systemDefinition;
  if (!attributes) {
    return null;
  }
  const { slots } = attributes;
  return getFromSetOrSlot(slot, slots);
}

export function getSystemProjectSet(set, systemProducts) {
  if (!set || !systemProducts) {
    return null;
  }
  const { attributes } = systemProducts;
  if (!attributes) {
    return null;
  }
  const { sets } = attributes;
  return getFromSetOrSlot(set, sets);
}

export function getComponentType(name) {
  if (!name) {
    return null;
  }
  if (typeof (name) === 'object') {
    return name;
  }
  return SLOT_SET_TYPE_ALIAS_MAP[name];
}


// Returns the 'sets' object of a 'systemProducts' object
export function getSystemProductSets(systemProducts) {
  if (!systemProducts) {
    return null;
  }
  const systemProductAttributes = systemProducts.attributes;
  return systemProducts.sets || (systemProductAttributes ? systemProductAttributes.sets : null);
}

export function idAsKey(id) {
  return typeof (id) === 'number' ? id.toString(16) : id;
}


export function findProductsBySlotNameAndIdFromMeta(slotName, id, systemProducts) {
  const meta = systemProducts.meta;
  if (!meta) {
    return null;
  }
  const { objectsBySlotAndID } = meta;
  if (!objectsBySlotAndID) {
    return null;
  }
  const map = objectsBySlotAndID[slotName];
  if (!map) {
    return null;
  }
  return map[idAsKey(id)];
}

function findProductsBySlotNameAndId(slotName, id, systemProducts, multiple) {
  const sets = getSystemProductSets(systemProducts);
  const list = getFromSetOrSlot(slotName, sets);
  const num = list ? list.length : 0;
  let res = null;
  for (let i = 0; i < num; i += 1) {
    const item = list[i];
    const itemId = item ? item.id : null;
    if (id === itemId) {
      if (multiple) {
        if (!res) {
          res = [];
        }
        res.push(item);
      } else {
        return item;
      }
    }
  }
  return res;
}

/**
 * @param {string} slotName
 * @param {number|string} id
 * @param {object} systemProducts
 * @param {boolean} multiple - if true, returns array with multiple matches. If not, returns one match, or null
 * @param {boolean} saveToCache - if true, saves the result to systemProducts.meta.objectsBySlotAndID[id] for faster lookup next time
 * */
export function getProductsBySlotNameAndId(slotName, id, systemProducts, multiple = true, saveToCache = true) {
  if (!slotName || !systemProducts) {
    return null;
  }
  const idType = typeof id;
  if (idType !== 'number' && idType !== 'string') {
    return null;
  }
  let res = findProductsBySlotNameAndIdFromMeta(slotName, id, systemProducts);
  if (res) {
    return res;
  }
  res = findProductsBySlotNameAndId(slotName, id, systemProducts, multiple);

  if (saveToCache) {
    const meta = systemProducts.meta || {};
    const products = systemProducts;
    products.meta = meta;

    const objectsBySlotAndID = meta.objectsBySlotAndID || {};
    meta.objectsBySlotAndID = objectsBySlotAndID;

    const map = objectsBySlotAndID[slotName] || {};
    objectsBySlotAndID[slotName] = map;

    map[idAsKey(id)] = res;
  }

  return res;
}

// #if DEBUG

const testSystemProducts = {
  replaceControlOfSetAction,
  replaceControlInConfigAction,
  getControlProductById(id, setName = null, amount = -1, multiple = false) {
    const { products } = testSystemProducts;
    return getControlProductById(id, products, setName, amount, multiple);
  },
  addControl(id, amount = 1, setName = null, destinationSlot = null) {
    const config = testSystemProducts.system;
    const { control, controlSet } = testSystemProducts.getControlProductById(id, setName, amount);
    addControlToConfig(control, controlSet, config, destinationSlot);
    return config;
  },
  test(args) {
    let action = 'collect';
    let controlSlot = 'controls-1';
    const config = testSystemProducts.system;
    const products = testSystemProducts.products;
    let newControl = null;
    let newControlSet = null;
    let data = null;

    if (args) {
      action = args.action || action;
      controlSlot = args.controlSlot || controlSlot;
      newControl = args.newControl || newControl;
      newControlSet = args.newControlSet || newControlSet;
      data = args.data || data;
    }

    this.addControl(1, 1);

    const res = replaceControlInConfigAction(
      action,
      controlSlot,
      config,
      products,
      newControl,
      newControlSet,
      data,
    );
    return res;
  },
  system: {
    attributes: {
      slots: {
        kettle: {
          id: 0,
        },
        'controls-1': false,
        'controls-2': false,
        'controls-3': false,
        'controls-4': false,
        'controls-5': false,
      },
    },
  },
  products: {
    attributes: {
      sets: {
        'control-1': [
          {
            id: 1,
            required: 0,
            amount: 1,
          },
          {
            id: 1,
            required: 0,
            amount: 2,
          },
          {
            id: 2,
            required: 0,
            amount: 1,
          },
        ],
        'control-2': [
          {
            id: 3,
            required: 1,
            amount: 2,
          },
          {
            id: 3,
            required: 1,
            amount: 3,
          },
          {
            id: 4,
            required: 1,
            amount: 1,
          },
        ],
        'control-3': [
        ],
      },
    },
  },
};
window.testSystemProducts = testSystemProducts;

// #endif



// WEBPACK FOOTER //
// ./js/utils/project-definition/project-definition-data-access.js